'use client';

import { useField } from 'formik';
import { FC } from 'react';

import { InputFormikProps } from './Input.type';
import { InputSelect } from './InputSelect';

/**
 * Input field expected to be used within a Formik context
 */
export const InputSelectFormik: FC<InputFormikProps<typeof InputSelect>> = (props) => {
  const [field, meta, helpers] = useField(props.name);
  return (
    <InputSelect
      {...props}
      value={field.value ?? ''}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(e) => helpers.setValue(e.target.value)}
      onBlur={() => helpers.setTouched(false)}
    />
  );
};
